/* Soluma Antioxidant PDP (template: product.indeks_antioxidant) */
(function () {
  function each(root, sel, fn) {
    root.querySelectorAll(sel).forEach(fn);
  }

  // Same A/B params the other checkout buttons append (ka_buy-page.js)
  function storageValue(key) {
    var value = null;
    try { value = localStorage.getItem(key); } catch (e) {}
    if (!value) return null;
    try {
      var parsed = JSON.parse(value);
      if (Array.isArray(parsed)) return parsed.join(',');
      if (parsed && typeof parsed === 'object') return Object.keys(parsed).map(function (k) { return parsed[k]; }).join(',');
    } catch (e) {}
    return value;
  }
  function absParams() {
    var out = '';
    [
      ['cc_custom__abs_id', 'abs-id'],
      ['cc_custom__abs_groups', 'abs-test-groups'],
      ['cc_custom__abs_shipping_groups', 'abs-shipping-test-groups'],
      ['cc_custom__abs_redirect_groups', 'abs-redirect-test-groups'],
      ['cc_custom__abs_theme_groups', 'abs-theme-test-groups'],
      ['cc_custom__abs_template_groups', 'abs-template-test-groups']
    ].forEach(function (p) {
      var v = storageValue(p[1]);
      if (v) out += '&' + p[0] + '=' + encodeURIComponent(v);
    });
    return out;
  }

  function initGallery(root) {
    each(root, '.ax-gal-m', function (gal) {
      var slides = gal.querySelectorAll('.ax-gm-slide');
      var thumbs = gal.querySelectorAll('.ax-th');
      var active = 0;
      function show(i) {
        active = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.hidden = n !== active; });
        thumbs.forEach(function (t, n) { t.classList.toggle('is-on', n === active); });
        if (thumbs[active]) thumbs[active].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
      thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
      var main = gal.querySelector('.ax-gm-main');
      var sx = null, sy = null;
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        sx = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(active + (dx < 0 ? 1 : -1));
      }, { passive: true });
    });
  }

  function initBuyBox(root) {
    each(root, '.ax-bb', function (bb) {
      var cards = bb.querySelectorAll('.ax-bcard');
      var footer = bb.querySelector('.ax-atc-foot');
      // Same text as other pages: [subscription_frequency] from the selected card
      // (getSubscriptionFrequencyLabel comes from ka_buy-page.js, loaded on every page)
      function updateFooter() {
        if (!footer) return;
        var card = bb.querySelector('.ax-bcard.is-on');
        var label = '';
        if (card) label = typeof getSubscriptionFrequencyLabel === 'function' ? getSubscriptionFrequencyLabel(card) : (card.getAttribute('data-subscription-frequency') || '');
        footer.textContent = footer.getAttribute('data-template').replace('[subscription_frequency]', label);
        footer.hidden = !label;
      }
      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          cards.forEach(function (c) {
            c.classList.toggle('is-on', c === card);
            c.setAttribute('aria-checked', c === card ? 'true' : 'false');
          });
          updateFooter();
        });
      });
      updateFooter();
      var atc = bb.querySelector('.ax-atc');
      if (atc) atc.addEventListener('click', function () {
        var card = bb.querySelector('.ax-bcard.is-on') || cards[0];
        var url = card && card.getAttribute('data-url');
        if (!url) return;
        var params = absParams();
        if (params && url.indexOf('?') === -1) params = '?' + params.slice(1);
        window.location.href = url + params;
      });
    });
    each(root, '.ax-deliv-date', function (el) {
      var d = new Date();
      d.setDate(d.getDate() + (parseInt(el.getAttribute('data-days'), 10) || 0));
      el.textContent = d.toLocaleDateString('en-US', { weekday: 'long' }) + ', ' + d.getDate() + ' ' + d.toLocaleDateString('en-US', { month: 'long' });
    });
    each(root, '.ax-facts', function (dialog) {
      each(root, '[data-ax-facts]', function (btn) { btn.addEventListener('click', function () { dialog.showModal(); }); });
      dialog.querySelector('.ax-fx').addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    });
  }

  // Dots that follow a horizontal scroll-snap slider
  function initSliders(root) {
    each(root, '[data-ax-slider]', function (track) {
      var dots = document.querySelectorAll('[data-ax-dots="' + track.getAttribute('data-ax-slider') + '"] .ax-dot');
      if (!dots.length) return;
      track.addEventListener('scroll', function () {
        var first = track.firstElementChild;
        if (!first) return;
        var i = Math.round(track.scrollLeft / (first.offsetWidth + 12));
        i = Math.max(0, Math.min(dots.length - 1, i));
        dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
      }, { passive: true });
    });
  }

  function initReviews(root) {
    each(root, '.ax-rv-more', function (more) {
      var list = more.parentNode.querySelector('.ax-rv-list');
      var step = parseInt(more.getAttribute('data-step'), 10) || 6;
      more.querySelector('button').addEventListener('click', function () {
        var hidden = list.querySelectorAll('.ax-rv.is-hid');
        for (var i = 0; i < hidden.length && i < step; i++) hidden[i].classList.remove('is-hid');
        if (hidden.length <= step) more.hidden = true;
      });
    });
  }

  // Smooth open/close for <details> (FAQ + buy box accordions)
  function initDetails(root) {
    each(root, 'details.ax-fq, details.ax-acc', function (d) {
      var summary = d.querySelector('summary');
      summary.addEventListener('click', function (e) {
        if (reduceMotion || !d.animate) return;
        e.preventDefault();
        var cs = getComputedStyle(d);
        var closed = summary.offsetHeight + parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom) + parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth);
        var from = d.offsetHeight;
        if (d._anim) d._anim.cancel();
        d.style.overflow = 'hidden';
        var opening = !d.open || d.classList.contains('is-closing');
        d.classList.toggle('is-closing', !opening);
        if (opening) d.open = true;
        var to = opening ? d.scrollHeight + parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth) : closed;
        d._anim = d.animate({ height: [from + 'px', to + 'px'] }, { duration: 320, easing: 'cubic-bezier(.25,.8,.25,1)' });
        d._anim.onfinish = function () {
          d._anim = null;
          d.style.overflow = '';
          if (!opening) { d.open = false; d.classList.remove('is-closing'); }
        };
      });
    });
  }

  // Count the first number in el's text up from 0 (keeps the rest, e.g. "−41 mg/dL")
  function countUp(el, delay) {
    var text = el.getAttribute('data-ax-text') || el.textContent;
    el.setAttribute('data-ax-text', text);
    var m = text.match(/\d+(?:[.,]\d+)?/);
    if (!m) return;
    var target = parseFloat(m[0].replace(',', '.'));
    var decimals = (m[0].split(/[.,]/)[1] || '').length;
    var render = function (v) { el.textContent = text.replace(m[0], v.toFixed(decimals).replace('.', m[0].indexOf(',') > -1 ? ',' : '.')); };
    render(0);
    setTimeout(function () {
      var start = null;
      function step(t) {
        if (start === null) start = t;
        var p = Math.min(1, (t - start) / 1200);
        render(target * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }, delay + 200);
  }

  // Fade/slide items in one by one as they scroll into view
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initReveal(root) {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var items = root.querySelectorAll('[data-ax-reveal]');
    if (!items.length) return;
    var observer = new IntersectionObserver(function (entries) {
      var n = 0;
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target, delay = n++ * 180;
        observer.unobserve(el);
        el.style.setProperty('--ax-d', delay + 'ms');
        el.classList.remove('is-pending');
        each(el, '[data-ax-count]', function (c) { countUp(c, delay); });
      });
    }, { threshold: 0.3 });
    items.forEach(function (el) {
      el.classList.add('is-pending');
      observer.observe(el);
    });
  }

  // Line that fills as the page scrolls past a list of markers (mechanism list + timeline)
  // Positions are measured once (and again when the page height changes); scrolling
  // only does math + a GPU transform, so the line stays in sync even on fast scrolls.
  var trackers = [];
  function pageTop(el) { return el.getBoundingClientRect().top + window.scrollY; }
  function measure() {
    trackers = [];
    document.querySelectorAll('.ax-nl-wrap').forEach(function (w) {
      var nbs = w.querySelectorAll('.ax-nb');
      if (nbs.length < 2) return;
      var centers = Array.prototype.map.call(nbs, function (nb) { return pageTop(nb) + nb.offsetHeight / 2; });
      var start = centers[0], end = centers[centers.length - 1];
      var track = w.querySelector('.ax-nl-track'), fill = w.querySelector('.ax-nl-fill');
      track.style.top = fill.style.top = (start - pageTop(w)) + 'px';
      track.style.height = fill.style.height = (end - start) + 'px';
      trackers.push({ fill: fill, start: start, end: end, points: centers, marks: nbs, cls: 'is-on' });
    });
    document.querySelectorAll('.ax-tl').forEach(function (tl) {
      var steps = tl.querySelectorAll('.ax-tl-step');
      if (!steps.length) return;
      var top = pageTop(tl);
      trackers.push({
        fill: tl.querySelector('.ax-tl-fill'),
        start: top + 10, end: top + tl.offsetHeight - 10,
        points: Array.prototype.map.call(steps, function (s) { return pageTop(s) + 22; }),
        marks: Array.prototype.map.call(steps, function (s) { return s.querySelector('.ax-tl-node'); }),
        pills: Array.prototype.map.call(steps, function (s) { return s.querySelector('.ax-tl-pill'); }),
        cls: 'is-on'
      });
    });
    updateProgress();
  }
  function updateProgress() {
    var mark = window.scrollY + window.innerHeight * 0.6;
    trackers.forEach(function (t) {
      var p = Math.max(0, Math.min(1, (mark - t.start) / (t.end - t.start)));
      t.fill.style.transform = 'scaleY(' + p.toFixed(4) + ')';
      var lit = 0;
      t.points.forEach(function (y) { if (y <= mark) lit++; });
      if (lit === t.lit) return;
      t.lit = lit;
      t.marks.forEach(function (m, n) { m.classList.toggle(t.cls, n < lit); });
      if (t.pills) t.pills.forEach(function (pl, n) { pl.classList.toggle('is-cur', n === lit - 1); });
    });
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; updateProgress(); });
  }
  var measureTimer;
  function remeasure() {
    clearTimeout(measureTimer);
    measureTimer = setTimeout(measure, 100);
  }

  function init(root) {
    initGallery(root);
    initBuyBox(root);
    initSliders(root);
    initReviews(root);
    initReveal(root);
    initDetails(root);
    measure();
  }

  init(document);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', remeasure);
  window.addEventListener('load', measure);
  if ('ResizeObserver' in window) new ResizeObserver(remeasure).observe(document.body);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
